import { useState, useEffect, useRef } from 'react';
import { inscrire, confirmerInscription } from '../api';

const champ = { width:'100%', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:9,
                padding:'11px 13px', color:'var(--text)', fontSize:14.5 };
const lib = { display:'block', fontSize:12, fontWeight:600, color:'var(--muted)', margin:'0 0 5px' };
const titreBloc = { fontSize:11, fontWeight:700, color:'var(--accent)', letterSpacing:1.5, textTransform:'uppercase', margin:'4px 0 12px' };
const logo = <img src="/img/logo-equipote.png" alt="Équipote" style={{ height:38, width:'auto', display:'block', margin:'0 auto 22px' }} />;

/**
 * Essai d'un mois en libre-service.
 *   mode « formulaire »  le club s'inscrit
 *   mode « confirmer »   il clique sur le lien reçu par email : l'essai s'ouvre
 */
export default function InscriptionPage({ token }) {
  return token ? <Confirmation token={token} /> : <Formulaire />;
}

function Formulaire() {
  const ouvertA = useRef(Date.now());
  const [f, setF] = useState({ atteste: false });
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [envoye, setEnvoye] = useState(null);
  const set = k => e => setF({ ...f, [k]: e.target.value });

  async function envoyer(e) {
    e.preventDefault();
    setEnvoi(true); setErreur(null);
    try {
      await inscrire({
        club:   { nom: f.club, code_ffhb: f.code || undefined, ville: f.ville },
        admin:  { prenom: f.prenom, nom: f.nom, email: f.email, fonction: f.fonction },
        equipe: { nom: f.equipe, categorie: f.categorie },
        atteste: f.atteste, site_web: f.site_web, ouvert_a: ouvertA.current
      });
      setEnvoye(f.email);
    } catch (err) { setErreur(err.message); }
    finally { setEnvoi(false); }
  }

  if (envoye) return (
    <div style={{ padding:'48px 22px', maxWidth:460, margin:'0 auto', textAlign:'center' }}>{logo}
      <div style={{ fontSize:40, marginBottom:12 }}>📬</div>
      <h1 style={{ fontFamily:'Barlow Condensed', fontSize:25, fontWeight:800 }}>Vérifiez vos emails</h1>
      <p style={{ color:'var(--muted)', fontSize:14.5, lineHeight:1.7, marginTop:12 }}>
        Un lien de confirmation vient de partir à <b style={{ color:'var(--text)' }}>{envoye}</b>.
        Cliquez dessus pour ouvrir l'espace de votre club : votre essai d'un mois démarrera à ce moment-là.
      </p>
      <p style={{ color:'var(--muted)', fontSize:12.5, marginTop:18 }}>Rien reçu ? Regardez dans les indésirables. Le lien est valable 48 heures.</p>
    </div>);

  return (
    <div style={{ padding:'32px 18px 44px', maxWidth:520, margin:'0 auto' }}>
      {logo}
      <h1 style={{ fontFamily:'Barlow Condensed', fontSize:28, fontWeight:800, textAlign:'center' }}>Essayez Équipote un mois</h1>
      <p style={{ color:'var(--muted)', fontSize:14, textAlign:'center', lineHeight:1.6, margin:'8px 0 26px' }}>
        Toutes les fonctionnalités, sans engagement et sans moyen de paiement.</p>

      <form onSubmit={envoyer}>
        <div style={titreBloc}>Votre club</div>
        <div style={{ marginBottom:11 }}><label style={lib}>Nom du club *</label>
          <input style={champ} value={f.club||''} onChange={set('club')} required maxLength={80} placeholder="HBC Val-de-Brume" /></div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:6 }}>
          <div><label style={lib}>Ville</label><input style={champ} value={f.ville||''} onChange={set('ville')} /></div>
          <div><label style={lib}>Code FFHandball</label>
            <input style={champ} value={f.code||''} onChange={set('code')} inputMode="numeric" maxLength={7} placeholder="7 chiffres" /></div>
        </div>
        <div style={{ fontSize:11.5, color:'var(--muted)', marginBottom:22, lineHeight:1.5 }}>
          Le code figure sur vos feuilles de match. Il permet d'importer les statistiques.</div>

        <div style={titreBloc}>Vous</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:11 }}>
          <div><label style={lib}>Prénom *</label><input style={champ} value={f.prenom||''} onChange={set('prenom')} required /></div>
          <div><label style={lib}>Nom *</label><input style={champ} value={f.nom||''} onChange={set('nom')} required /></div>
        </div>
        <div style={{ marginBottom:11 }}><label style={lib}>Email *</label>
          <input style={champ} type="email" value={f.email||''} onChange={set('email')} required autoComplete="email" /></div>
        <div style={{ marginBottom:22 }}><label style={lib}>Fonction au club</label>
          <input style={champ} value={f.fonction||''} onChange={set('fonction')} placeholder="Président, secrétaire, entraîneur…" /></div>

        <div style={titreBloc}>Votre première équipe</div>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:22 }}>
          <div><label style={lib}>Nom</label><input style={champ} value={f.equipe||''} onChange={set('equipe')} placeholder="Seniors M" /></div>
          <div><label style={lib}>Catégorie</label><input style={champ} value={f.categorie||''} onChange={set('categorie')} placeholder="-18 F" /></div>
        </div>

        {/* Champ piège : invisible pour un humain, rempli par les robots */}
        <div aria-hidden="true" style={{ position:'absolute', left:'-9999px', width:1, height:1, overflow:'hidden' }}>
          <label>Site web<input tabIndex={-1} autoComplete="off" value={f.site_web||''} onChange={set('site_web')} /></label>
        </div>

        <label style={{ display:'flex', gap:10, alignItems:'flex-start', cursor:'pointer', fontSize:13.5, lineHeight:1.55, marginBottom:18 }}>
          <input type="checkbox" checked={f.atteste} onChange={e => setF({ ...f, atteste: e.target.checked })}
                 style={{ width:19, height:19, flexShrink:0, marginTop:1, accentColor:'var(--accent)' }} />
          <span>J'atteste agir pour le compte de ce club et être habilité à ouvrir cet essai.</span>
        </label>

        {erreur && <div style={{ color:'var(--danger)', fontSize:13.5, marginBottom:14, textAlign:'center' }}>{erreur}</div>}
        <button className="btn btn-primary" disabled={envoi || !f.atteste} style={{ opacity: envoi || !f.atteste ? .55 : 1 }}>
          {envoi ? 'Envoi…' : 'Démarrer mon essai gratuit'}</button>
        <p style={{ fontSize:11.5, color:'var(--muted)', textAlign:'center', marginTop:14, lineHeight:1.6 }}>
          À l'issue du mois d'essai, l'accès est suspendu sauf si vous choisissez de vous abonner — 25 € TTC par mois ou 250 € TTC la saison,
          toutes équipes comprises. Vos données sont conservées trois mois.</p>
      </form>
      <p style={{ textAlign:'center', marginTop:22, fontSize:13 }}>
        <a href="/" style={{ color:'var(--muted)' }}>Déjà inscrit ? Se connecter</a></p>
    </div>
  );
}

function Confirmation({ token }) {
  const [etat, setEtat] = useState({ charge: true });
  const lance = useRef(false);
  useEffect(() => {
    if (lance.current) return;     // une seule confirmation, même si la page se rafraîchit
    lance.current = true;
    confirmerInscription(token).then(r => setEtat({ ok: r }))
      .catch(e => setEtat({ erreur: e.message }));
  }, [token]);

  const fr = iso => iso ? iso.split('-').reverse().join('/') : '';
  const cadre = { padding:'48px 22px', maxWidth:460, margin:'0 auto', textAlign:'center' };
  if (etat.charge) return <div style={{ ...cadre, color:'var(--muted)' }}>{logo}Ouverture de votre espace…</div>;
  if (etat.erreur) return (
    <div style={cadre}>{logo}<div style={{ fontSize:36, marginBottom:10 }}>⚠️</div>
      <p style={{ color:'var(--muted)', fontSize:14.5, lineHeight:1.7 }}>{etat.erreur}</p>
      <a href="/" className="btn btn-secondary" style={{ display:'inline-block', width:'auto', padding:'10px 20px', marginTop:16, textDecoration:'none' }}>Se connecter</a>
    </div>);
  const r = etat.ok;
  // À la connexion qui suit, le président arrivera sur « Mon club »
  try { sessionStorage.setItem('equipote:ouvrir', JSON.stringify({ page: 'club', expire: Date.now() + 10 * 60 * 1000 })); } catch {}
  return (
    <div style={cadre}>{logo}
      <div style={{ fontSize:42, marginBottom:10 }}>🎉</div>
      <h1 style={{ fontFamily:'Barlow Condensed', fontSize:26, fontWeight:800 }}>L'espace de {r.club} est ouvert</h1>
      <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7, margin:'10px 0 18px' }}>
        Votre essai court jusqu'au <b style={{ color:'var(--text)' }}>{fr(r.fin)}</b>. Voici vos accès, également envoyés par email :</p>
      <div style={{ fontFamily:'monospace', fontSize:14.5, lineHeight:1.9, background:'var(--bg)', border:'1px solid var(--border)',
                    borderRadius:10, padding:'12px 16px', textAlign:'left', display:'inline-block', minWidth:250 }}>
        <div>Identifiant : <b>{r.username}</b></div>
        <div>Mot de passe : <b style={{ color:'#22c55e' }}>{r.password}</b></div>
      </div>
      <p style={{ color:'var(--muted)', fontSize:12.5, margin:'14px 0 20px' }}>Notez ce mot de passe : il ne sera plus affiché.</p>
      <a href="/?connexion" className="btn btn-primary" style={{ display:'inline-block', width:'auto', padding:'12px 26px', textDecoration:'none' }}>
        Me connecter</a>
    </div>
  );
}
